<template>
  <div class="input-with-edit">
    {{ model || '—' }}

    <small>USD</small>

    <q-btn icon="edit" flat size="sm" round class="q-ml-xs" />

    <q-popup-edit
      v-model="model"
      :title="title"
      buttons
      content-style="visibility: visible"
      @save="save"
      @before-show="setCleaveFields"
    >
      <q-input ref="input" :value="model" dense autofocus />
    </q-popup-edit>
  </div>
</template>

<script>
import cleaveMixin from '@/mixins/cleave-mixin'
import priceFormat from '@/mixins/price-format'

export default {
  mixins: [cleaveMixin, priceFormat],

  props: {
    value: [String, Number],
    title: String
  },

  data() {
    return {
      model: null,
      rawModel: this.value
    }
  },

  created() {
    this.model = this.pf_convertNumberToPrice(this.value)
  },

  methods: {
    async setCleaveFields() {
      await this.$nextTick()
      this.inputPriceFormat('.q-field__native', 2, ({ target: valueChanged }) => {
        this.model = valueChanged.value
        this.rawModel = +valueChanged.rawValue || ''
      })
    },

    save(newVal, oldVal) {
      this.$emit('input', newVal)
      this.$emit('update', this.rawModel, oldVal)
    }
  }
}
</script>
